import React from 'react';
import { useTranslation } from 'react-i18next';

const AnnouncementMarquee = () => {
  const { t } = useTranslation();
  const text = t('marquee.text');
  const repeated = Array(8).fill(null);

  return (
    <div
      className="relative z-10 w-full overflow-hidden py-3 shadow-md"
      style={{
        background: 'linear-gradient(90deg, #d97706 0%, #f59e0b 50%, #d97706 100%)',
        minHeight: '48px',
      }}
    >
      <div className="flex animate-marquee whitespace-nowrap items-center">
        {repeated.map((_, i) => (
          <span key={i} className="mx-8 flex items-center gap-2 text-base font-semibold">
            <span className="text-white" style={{ textShadow: '0 1px 2px rgba(0,0,0,0.3)' }}>
              {text}
            </span>
            <a
              href="https://forms.gle/w6r44LkLr27ALTAa8"
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2 inline-flex items-center rounded-md bg-white px-4 py-1.5 text-sm font-bold shadow-sm transition hover:bg-amber-50"
              style={{ color: '#b45309' }}
            >
              {t('marquee.joinNow')}
            </a>
            <span className="text-amber-200">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementMarquee;
